import React from "react";

function Trade({ trade_data }) {
  if (
    trade_data !== "" &&
    trade_data.status !== 404 &&
    trade_data.totalRecords !== 0
  ) {
    return (
      <div className="my-3">
        <h3 className="">Trade Data</h3>
        <table className="table text-dark table-striped table-responsive">
          <thead>
            <tr className="mb-2">
              <th>Date</th>
              <th>TimeStamp</th>
              <th>Price</th>
              <th>Volume</th>
              <th>TickDirection</th>
              <th>Change</th>
            </tr>
          </thead>
          <tbody>
            {trade_data.records.map((data, index) => {
              return (
                <tr key={index} className="mb-2">
                  <td>{data.tradeDate}</td>
                  <td>{data.tradeTime}</td>
                  <td>{data.lastPrice}</td>
                  <td>{data.lastVolume}</td>
                  <td>{data.tradeDirection}</td>
                  <td>{data.change}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  } else {
    return "";
  }
}

function Disclosure({ disclosure }) {
  if (
    disclosure !== "" &&
    disclosure.status !== 404 &&
    disclosure.totalRecords !== 0
  ) {
    return (
      <div className="my-3">
        <h3 className="">Financial Disclosure</h3>
        <table className="table text-dark table-striped table-responsive">
          <thead>
            <tr className="mb-2">
              <th>Publish Date</th>
              <th>Title</th>
              <th>Company Name</th>
              <th>Period End Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {disclosure.records.map((data, index) => {
              return (
                <tr key={index} className="mb-2">
                  <td>{new Date(data.releaseDate * 1000).toString()}</td>
                  <td>{data.name}</td>
                  <td>{data.companyName}</td>
                  <td>{new Date(data.periodDate * 1000).toString()}</td>
                  <td>{data.statusId}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  } else {
    return "";
  }
}

function Quote({ quote }) {
  if (quote !== "" && quote.status !== 404 && quote.totalRecords !== 0) {
    return (
      <div className="my-3">
        <h3 className="font-bold text-xl text-sm-2xl">Quote Data</h3>
        <p className="font-bold">{quote.symbol}</p>
        <p>Last Price: {quote.lastSale}</p>
        <p>Volume: {quote.volume}</p>
        <p>Bid Price: {quote.bidPrice}</p>
        <p>Ask Price: {quote.askPrice}</p>
        <p>
          Percentage Change :{" "}
          {quote.percentChange.toString().includes("-") ? (
            <span className="text-danger text-bold">
              {quote.percentChange}
              {" %"}
            </span>
          ) : quote.percentChange === 0 ? (
            <span>{quote.percentChange}</span>
          ) : (
            <span className="text-success text-bold">
              {quote.percentChange} {" %"}
            </span>
          )}
        </p>
        <p>High : {quote.dailyHigh}</p>
        <p>Low : {quote.dailyLow}</p>
        <p>52-Week High : {quote.annualHigh}</p>
        <p>52-Week Low : {quote.annualLow}</p>
      </div>
    );
  } else {
    return "";
  }
}

function FinancialReporting({ profile }) {
  if (profile !== "" && profile.status !== 404 && profile.totalRecords !== 0) {
    return (
      <div className="mt-3 mt-sm-5">
        <h3 className="font-bold text-xl text-sm-2xl">Financial Reporting</h3>
        <table className="table table-responsive table-striped text-dark">
          <tbody>
            <tr>
              <td>Reporting Status</td>
              <td>{profile.reportingStandard}</td>
            </tr>
            <tr>
              <td>Audited Financials</td>
              <td>{profile.auditedStatusDisplay}</td>
            </tr>
            <tr>
              <td>CIK</td>
              <td>{profile.cik}</td>
            </tr>
            <tr>
              <td>Fiscal Year End</td>
              <td>{profile.fiscalYearEnd}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  } else {
    return "";
  }
}

function ShortInterest({ shortInterest }) {
  if (
    shortInterest !== "" &&
    shortInterest.status !== 404 &&
    shortInterest.totalRecords !== 0
  ) {
    return (
      <div>
        <h3 className="font-bold text-xl text-sm-2xl">Short Interest</h3>
        <table className="table text-dark table-striped table-responsive">
          <thead>
            <tr className="mb-2">
              <th>Date</th>
              <th>Short Interest</th>
              <th>% Change</th>
              <th>Avg Daily Share Volume</th>
              <th>Days To Cover</th>
              <th>Split</th>
              <th>New Issue</th>
            </tr>
          </thead>
          <tbody>
            {shortInterest.records.map((data, index) => {
              return (
                <tr key={index} className="mb-2 text-center">
                  <td>{data.positionDate}</td>
                  <td>{data.shortInterest}</td>
                  <td>{data.pctChgVolume.toString()}</td>
                  <td>{data.avgDailyVolume}</td>
                  <td>{data.daysToCover}</td>
                  <td>{data.isSplit.toString()}</td>
                  <td>{data.isNewIssue.toString()}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  } else {
    return "";
  }
}

function QuoteContainer({
  short_interest,
  trade_data,
  quote,
  disclosure,
  profile
}) {
  return (
    <div className="px-2 px-sm-5">
      <Quote quote={quote} />
      <Trade trade_data={trade_data} />
      <ShortInterest shortInterest={short_interest} />
      <FinancialReporting profile={profile} />
      <Disclosure disclosure={disclosure} />
    </div>
  );
}

export default QuoteContainer;
